/** @format */

import {TFunction} from 'i18next';

import {sensorName} from 'helpers/sensor_names';

interface Check {
  found: number;
  sensor: {
    name: string;
    isError?: boolean;
  };
}

const sortChecks = <C extends Check>(checks: C[], translate: TFunction): C[] => {
  return checks.toSorted((a, b) => {
    if (a.found !== b.found) {
      return b.found - a.found;
    }

    if (!a.sensor.isError && b.sensor.isError) {
      return 1;
    }

    if (a.sensor.isError && !b.sensor.isError) {
      return -1;
    }

    const nameA = translate(sensorName(a.sensor.name));
    const nameB = translate(sensorName(b.sensor.name));
    return nameA.localeCompare(nameB);
  });
};

export {sortChecks};
